/* eslint-disable */
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Avatar,
  Badge,
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  IconButton,
  Image,
  Input,
  Select,
  SimpleGrid,
  Skeleton,
  Spinner,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionTr = motion(Tr as any);
import { MdChevronRight, MdChevronLeft, MdAdd, MdDownload, MdWarning, MdDelete, MdUndo, MdSend, MdRefresh, MdCancel, MdEdit, MdVisibility, MdVerifiedUser, MdInfoOutline } from 'react-icons/md';

import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import { useRef } from 'react';
import resguardosApi from 'api/resguardos';
import activosApi from 'api/activos';
import hotelesApi from 'api/hoteles';
import { isSoloLectura } from 'utils/permissions';
import {
  PaginationState,
  createColumnHelper,
  useReactTable,
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table';

type RowObj = {
  emailAsociado_resguardo: string;
  name: string[]; // ['Nombre', 'URL Imagen']
  departamento: string;
  departamentoColaborador: string;
  fechaInicio: string;
  orders: string | number;
  ResguardoId: number;
  Usuario: string;
  FirmaDigital: string;
  Estado: string;
  usuarioDueno: string;
  usuarioNumColab: string;
  Motivo: string | null;
  CreatedDate: string;
  LastModifiedDate: string;
  NombreActivos: string;
  SerialNumbers: string;
  Folios: string;
};

interface Activo {
  Estado: string;
  EstadosId: string;
  HotelId: any;
  Id: number;
  ActiveName: string;
  SerialNumber: string;
  Modelo?: string;
  Inventario?: string;
  activoDueno?: string;
  Folio?: string;
  // agrega las demás propiedades que necesites
}

const DetailItem = ({ label, value }: { label: string; value: string }) => (
  <Box>
    <Text fontSize="sm" color="gray.500" mb="1">
      {label}
    </Text>
    <Text fontWeight="medium">{value || 'No especificado'}</Text>
  </Box>
);

export default function SearchTableOrders() {
  const toast = useToast();
  const { isOpen: isDrawerOpen, onOpen: onOpenDrawer, onClose: onCloseDrawer } = useDisclosure();
  const [selectedResguardo, setSelectedResguardo] = React.useState<RowObj | null>(null);
  const [data, setData] = React.useState<RowObj[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isLoadingDrawer, setIsLoadingDrawer] = React.useState(false);
  const [globalFilter, setGlobalFilter] = React.useState('');
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>([]);
  const [catalogoActivos, setCatalogoActivos] = React.useState<Activo[]>([]);
  const [editableActivos, setEditableActivos] = React.useState<Activo[]>([]);
  // Departamento del dueño congelado al momento de cancelar (viene del snapshot histórico).
  // null cuando el resguardo no está cancelado o aún no se cargó.
  const [departamentoHistorico, setDepartamentoHistorico] = React.useState<string | null>(null);
  const [hayCambiosPendientes, setHayCambiosPendientes] = React.useState(false);
  const [nuevaFirmaDigital, setNuevaFirmaDigital] = React.useState('');
  const [showSignaturePad, setShowSignaturePad] = React.useState(false);
  const [correoColaborador, setCorreoColaborador] = React.useState('');
  const [searchField, setSearchField] = React.useState('todos'); // 'todos', 'colaborador', 'departamento', 'estado'
  const [showDeleteAlert, setShowDeleteAlert] = React.useState(false);
  const [showDesasignarActivo, setDesasignarActivo] = React.useState(false);
  const [showDesasignarActivoAviso, setDesasignarActivoAviso] = React.useState(false);
  const [lastActivosBackup, setLastActivosBackup] = React.useState<Activo[]>([]);
  const [activosSeleccionados, setActivosSeleccionados] = React.useState<number[]>([]);
  const [modoDesasignacion, setModoDesasignacion] = React.useState(false);
  const [showUnicoActivoAlert, setShowUnicoActivoAlert] = React.useState(false);
  const [busquedaNuevoActivo, setBusquedaNuevoActivo] = React.useState('');
  // Estado "Autorizado": el supervisor elige si la firma será remota (enlace por correo) o presencial (en este dispositivo)
  const [modoFirma, setModoFirma] = React.useState<'remota' | 'presencial' | null>(null);
  // Copia opcional a otros correos + mensaje personalizado al enviar el enlace de firma (estado "Autorizado")
  const [enviarCopiaCorreos, setEnviarCopiaCorreos] = React.useState(false);
  const [copiaCorreosInput, setCopiaCorreosInput] = React.useState('');
  const [mensajePersonalizadoCorreo, setMensajePersonalizadoCorreo] = React.useState('');

  // Al autorizar (supervisor/admin), si ya tiene una firma registrada (tbaFirmas_user,
  // viene en sessionStorage.user.Firma desde el login) se usa esa en vez de pedirle
  // que dibuje una nueva cada vez. Puede optar por dibujar una distinta.
  const [usarNuevaFirmaAutorizacion, setUsarNuevaFirmaAutorizacion] = React.useState(false);

  const [sinCorreo, setSinCorreo] = React.useState(false);
  const CORREO_DEFAULT = "jclizarraga@velasresorts.com"; // Define aquí tu correo default
  const [canvasVacio, setCanvasVacio] = React.useState(true);
  const [showCancelAlert, setShowCancelAlert] = React.useState(false);
  const [motivoCancelacion, setMotivoCancelacion] = React.useState('');
  const cancelRef = React.useRef(); // Referencia necesaria para el foco del AlertDialog
  const [enviandoFirmaRemota, setEnviandoFirmaRemota] = React.useState(false);

  const sigCanvas = useRef<SignatureCanvas>(null);
  // Agrega esta función después de las demás funciones y antes del return principal

  // Función para validar email
  const validarEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Convierte "a@x.com, b@x.com" en una lista de correos válidos y únicos
  const parsearCorreosDeCopia = (texto: string): string[] => {
    const validos = texto.split(',').map((c) => c.trim()).filter((c) => c && validarEmail(c));
    return Array.from(new Set(validos));
  };

  const toggleSeleccionActivo = (activoId: number) => {
    setActivosSeleccionados(prev =>
      prev.includes(activoId)
        ? prev.filter(id => id !== activoId)
        : [...prev, activoId]
    );
  };

  const cancelarDesasignacion = () => {
    setActivosSeleccionados([]);
    setModoDesasignacion(false);
    setDesasignarActivoAviso(false);
  };

  // Esta función solo abre el modal de advertencia
  const handleConfirmarCancelacion = () => {
    setMotivoCancelacion('');
    setShowCancelAlert(true);
  };

  // Esta función es la que realmente llama a la API
  const ejecutarCancelacionReal = async () => {
    if (!selectedResguardo) return;
    if (!motivoCancelacion.trim()) return;
    try {
      // 1. Desasignar todos los activos vinculados para que queden libres (Estado 1)
      for (const activo of editableActivos) {
        await activosApi.editar(activo.Id.toString(), {
          EstadosId: '1', // "Activo/Disponible"
        });
        // Opcional: registrar en historial de activo si tu API lo permite
      }

      // 2. Llamada a la API para cambiar estatus a CANCELADO
      // Enviar el nuevo estado y marcar que no hay activos vigentes
      const dataUser = JSON.parse(sessionStorage.getItem("user") || "{}");
       await resguardosApi.editar(selectedResguardo.ResguardoId, {
        status: 'CANCELADO',
        Motivo: motivoCancelacion.trim(),
        UsuarioId: dataUser.Id
      });

      toast({
        title: "Resguardo cancelado",
        description: "Los activos están disponibles y el registro se movió al historial.",
        status: "info",
        duration: 5000,
        isClosable: true,
      });

      setShowCancelAlert(false);
      setMotivoCancelacion('');
      onCloseDrawer();
      actualizarListaResguardos(); // Refrescar tabla
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: "No se pudo procesar la cancelación.",
        status: "error"
      });
    }
  };
  const confirmarDesasignacionMultiple = async () => {
    if (activosSeleccionados.length === 0 || !selectedResguardo) return;

    try {
      // Crear la lista de activos actualizada ANTES de hacer las operaciones

      const nuevosActivos = editableActivos.filter(activo =>
        !activosSeleccionados.includes(activo.Id)
      );

      // Desasignar cada activo seleccionado
      for (const activoId of activosSeleccionados) {
        const activo = editableActivos.find(a => a.Id === activoId);
        if (activo) {
          // 1. Cambiar el estado del activo a "Activo"
          await activosApi.editar(activo.Id.toString(), {
            EstadosId: '1', // Estado "Activo"
          });

          // 2. Quitar el activo del resguardo en la base de datos
          await resguardosApi.quitarDeResguardo(
            selectedResguardo.ResguardoId,
            activo.Id
          );
        }
      }

      // 3. Actualizar la lista de activos en el estado
      setEditableActivos(nuevosActivos);

      // Verificar si queda solo un activo después de la desasignación
      if (nuevosActivos.length === 1) {
        // No mostramos alerta aquí, solo cuando el usuario intente desasignar el último
      }
      // Verificar si no quedan activos
      else if (nuevosActivos.length === 0) {
        setLastActivosBackup([...editableActivos]);
        setShowDeleteAlert(true);
      }

      // Limpiar selección y cerrar modo desasignación
      setActivosSeleccionados([]);
      setModoDesasignacion(false);
      setDesasignarActivoAviso(false);

      toast({
        title: "Activos desasignados",
        description: `${activosSeleccionados.length} activo(s) han sido desasignados correctamente`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });



      // Función para validar email
      const validarEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };

      // Modifica la función enviarFirmaColaborador para incluir confirmación
      const enviarFirmaColaborador = async (resguardoId: number, firmaDigital: string) => {
        try {
          // Validar el correo electrónico
          if (!correoColaborador || !validarEmail(correoColaborador)) {
            toast({
              title: "Correo inválido",
              description: "Por favor ingresa un correo electrónico válido",
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "top-right"
            });
            return;
          }

          // Mostrar confirmación antes de enviar
          const confirmacion = window.confirm(
            `¿Estás seguro de que deseas enviar la firma y activos al correo ${correoColaborador}?\n\nEsta acción no se puede deshacer.`
          );

          if (!confirmacion) {
            toast({
              title: "Acción cancelada",
              description: "El envío de la firma ha sido cancelado",
              status: "info",
              duration: 3000,
              isClosable: true,
              position: "top-right"
            });
            return;
          }

          const colaborador = JSON.parse(sessionStorage.getItem("colaborador") || "{}");
          const dataUser = JSON.parse(sessionStorage.getItem("user") || "{}");

          const body = {
            resguardoId,
            firmaDigital,
            activos: editableActivos.map(a => a.Id),
            colaborador: {
              ...colaborador,
              email: correoColaborador
            },
            Rol: dataUser.RolId,
            infoUser: dataUser
          };

          const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/firma-colaborador', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error('Error al guardar la firma del colaborador y los activos');
          }

          const data = await response.json();
          console.log('Firma y activos guardados:', data);

          // Esperar 3 segundos para actualizar
          setTimeout(() => {
            actualizarListaResguardos();
          }, 3000);

          // Mostrar notificación de éxito
          toast({
            title: "Firma y activos enviados",
            description: `Se ha enviado una copia al correo: ${correoColaborador}`,
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top-right"
          });

          return data;
        } catch (error) {
          console.error('Error:', error);

          // Mostrar notificación de error
          toast({
            title: "Error al enviar",
            description: "Ocurrió un error al enviar la firma y los activos",
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "top-right"
          });

          throw error;
        }
      };

      // También modifica la función enviarFirmaColaboradorUpdate para incluir validaciones
      const enviarFirmaColaboradorUpdate = async (resguardoId: number, firmaDigital: string) => {
        try {
          // Validar el correo electrónico del resguardo seleccionado
          const emailResguardo = selectedResguardo?.emailAsociado_resguardo;
          if (!emailResguardo || !validarEmail(emailResguardo)) {
            toast({
              title: "Correo no válido",
              description: "El correo asociado al resguardo no es válido. No se puede enviar la actualización.",
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "top-right"
            });
            return;
          }

          // Mostrar confirmación
          const confirmacion = window.confirm(
            `¿Estás seguro de que deseas enviar la actualización de activos al correo ${emailResguardo}?\n\nSe enviará el nuevo listado de activos.`
          );

          if (!confirmacion) {
            toast({
              title: "Actualización cancelada",
              description: "El envío de la actualización ha sido cancelado",
              status: "info",
              duration: 3000,
              isClosable: true,
              position: "top-right"
            });
            return;
          }

          const colaborador = JSON.parse(sessionStorage.getItem("colaborador")) || {};
          const dataUser = JSON.parse(sessionStorage.getItem("user")) || {};

          const body = {
            resguardoId,
            firmaDigital,
            activos: nuevosActivos.map(a => a.Id),
            colaborador: {
              ...colaborador,
              email: emailResguardo
            },
            Rol: dataUser.RolId,
            infoUser: dataUser
          };

          const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/firma-colaborador?isUpdate=1', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error('Error al guardar la firma del colaborador y los activos');
          }

          const data = await response.json();
          console.log('Firma y activos guardados:', data);

          // Esperamos 3 segundos para actualizar
          setTimeout(() => {
            actualizarListaResguardos();
          }, 3000);

          // Mostrar notificación de éxito
          toast({
            title: "Actualización enviada",
            description: `Hemos enviado una copia de los activos actualizados al correo: ${emailResguardo}`,
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top-right"
          });

          return data;
        } catch (error) {
          console.error('Error:', error);

          // Mostrar notificación de error
          toast({
            title: "Error al enviar",
            description: "Ocurrió un error al enviar la actualización de activos",
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "top-right"
          });

          throw error;
        }
      };
      setTimeout(async () => {
        await actualizarListaResguardos();
        await enviarFirmaColaboradorUpdate(selectedResguardo.ResguardoId, nuevaFirmaDigital);
      }, 3000);

    } catch (error) {
      console.error('Error al desasignar los activos:', error);
      toast({
        title: "Error",
        description: "No se pudieron desasignar los activos",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const descargarPDF = async (resguardoId: number) => {
    try {
      const response = await fetch(`https://inventariosbackend.velasresorts.com/inventarios/resguardos/descargar-pdf/${resguardoId}`);

      if (!response.ok) {
        // Si hay error, intentamos obtener más información
        const errorData = await response.text();
        console.error('Error response:', errorData);
        throw new Error(`Error al descargar el PDF: ${response.status} ${response.statusText}`);
      }

      // Obtener el nombre del archivo del header Content-Disposition
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = `resguardo_${resguardoId}.pdf`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      const blob = await response.blob();

      // Verificar que el blob sea un PDF
      if (blob.type !== 'application/pdf') {
        console.warn('El tipo de archivo no es PDF:', blob.type);
        // Podría ser un error JSON en lugar de un PDF
        const text = await blob.text();
        try {
          const errorData = JSON.parse(text);
          throw new Error(errorData.error || 'Error al descargar el PDF');
        } catch (e) {
          throw new Error('El servidor no devolvió un PDF válido');
        }
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      // Limpiar
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast({
        title: "PDF descargado",
        description: "El PDF se ha descargado correctamente",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error al descargar PDF:', error);
      toast({
        title: "Error al descargar",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Arma las filas de la tabla y, para los resguardos ya CANCELADOS, sobreescribe
  // departamento/departamentoColaborador/NombreActivos con el snapshot congelado
  // al momento de la cancelación — así reasignar después el mismo activo a otro
  // resguardo (otro departamento, otro colaborador) ya no afecta lo cancelado.
  const construirFilasResguardos = async (res: any[]): Promise<RowObj[]> => {
    const formattedData: RowObj[] = res.map((item: any) => ({
      name: [item.usuarioDueno, item.imagen || 'https://via.placeholder.com/60'],
      departamento: item.Departamento,
      departamentoColaborador: item.DepartamentoColaborador || '',
      fechaInicio: item.FechaInicio,
      orders: 'Activos',
      ResguardoId: item.ResguardoId,
      Usuario: item.Usuario,
      FirmaDigital: item.FirmaDigital,
      Estado: item.status || 'PENDIENTE',
      usuarioDueno: item.usuarioDueno,
      usuarioNumColab: item.usuarioNumColab,
      Motivo: item.Motivo,
      CreatedDate: item.CreatedDate,
      LastModifiedDate: item.LastModifiedDate,
      NombreActivos: item.NombreActivos,
      SerialNumbers: item.SerialNumbers || item.NumerosSerie || '',
      Folios: item.Folios || '',
      emailAsociado_resguardo: item.emailAsociado_resguardo || item.correo || item.email || 'N/A'
    }));

    const idsCancelados = formattedData
      .filter(row => row.Estado === 'CANCELADO')
      .map(row => row.ResguardoId);

    if (idsCancelados.length > 0) {
      const historicos = await resguardosApi.obtenerHistoricoBatch(idsCancelados);
      const historicoPorId = new Map(historicos.map((h: any) => [h.ResguardoId, h]));

      formattedData.forEach(row => {
        const historico: any = historicoPorId.get(row.ResguardoId);
        if (!historico) return;

        const nombreDepto = historico.ResguardoSnapshot?.usuarioDepartamento;
        if (nombreDepto) {
          row.departamento = nombreDepto;
          row.departamentoColaborador = nombreDepto;
        }

        if (Array.isArray(historico.ActivosSnapshot) && historico.ActivosSnapshot.length > 0) {
          row.NombreActivos = historico.ActivosSnapshot
            .map((a: any) => a.Activo)
            .filter(Boolean)
            .join(', ');
          row.SerialNumbers = historico.ActivosSnapshot
            .map((a: any) => a.SerialNumber)
            .filter(Boolean)
            .join(', ');
          row.Folios = historico.ActivosSnapshot
            .map((a: any) => a.Folio)
            .filter(Boolean)
            .join(', ');
        }
      });
    }

    return formattedData;
  };

  // Agregar esta función después de los estados
  const actualizarListaResguardos = async () => {
    try {
      const res = await resguardosApi.listadoId(userHotelIds);
      const formattedData = await construirFilasResguardos(res);
      setData(formattedData);
    } catch (error) {
      console.error('Error al actualizar lista:', error);
    }
  };

  const enviarFirmaColaborador = async (resguardoId: number, firmaDigital: string, emailManual?: string) => {
    try {
      const colaborador = JSON.parse(sessionStorage.getItem("colaborador")) || {};
      const dataUser = JSON.parse(sessionStorage.getItem("user")) || {};

      const body = {
        resguardoId,
        firmaDigital,
        activos: editableActivos.map(a => a.Id),
        colaborador: {
          ...colaborador,
          // PRIORIDAD: 1. Email manual pasado por el botón, 2. Estado local, 3. SessionStorage
          email: emailManual || correoColaborador || colaborador.email
        },
        Rol: dataUser.RolId,
        infoUser: dataUser
      };
      const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/firma-colaborador', {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Error al guardar la firma del colaborador y los activos');
      }

      const data = await response.json();
      console.log('Firma y activos guardados:', data);

      //esperamos 3 segundos para actualizar
      setTimeout(() => {
        actualizarListaResguardos();
      }, 3000);





      // Mostrar notificación de éxito
      toast({
        title: "Firma y activos guardados",
        description: "La firma del colaborador y los activos han sido registrados correctamente",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top-right"
      });

      return data;
    } catch (error) {
      console.error('Error:', error);

      // Mostrar notificación de error
      toast({
        title: "Error al guardar",
        description: "Ocurrió un error al registrar la firma del colaborador y los activos",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right"
      });

      throw error;
    }
  };

  // Obtener los HotelIds del usuario desde sessionStorage
  const userData = JSON.parse(sessionStorage.getItem("user") || "{}");
  const todosMisHotelIds = userData.HotelIds || [];

  // Mapeo Abrev→HotelId para resolver el selector de hotel del nav
  // (sessionStorage.hotelSeleccionado), construido del catálogo real de
  // hoteles — no hardcodeado, para no tener que tocar código si se agrega,
  // renombra o reordena un hotel.
  const [hotelesCatalogo, setHotelesCatalogo] = React.useState<any[]>([]);
  React.useEffect(() => {
    hotelesApi.listado().then((data: any) => setHotelesCatalogo(Array.isArray(data) ? data : []));
  }, []);

  const abrevAHotelId = React.useMemo(() => {
    const map: Record<string, number> = {};
    hotelesCatalogo.forEach((h: any) => { if (h.Abrev) map[h.Abrev] = h.Id; });
    return map;
  }, [hotelesCatalogo]);

  const [hotelSeleccionadoId, setHotelSeleccionadoId] = React.useState<number | null>(null);

  // El nav no dispara ningún evento al cambiar de hotel — se revisa por
  // polling, igual que ya hace Importar Activos. Se resuelve también de
  // inmediato (no solo en cada tick del interval) para no quedarse hasta
  // 1s pidiendo resguardos con el filtro equivocado apenas carga el
  // catálogo de hoteles (causaba que la lista se viera desactualizada
  // hasta refrescar la página).
  React.useEffect(() => {
    const resolverHotelSeleccionado = () => {
      const actual = abrevAHotelId[sessionStorage.getItem('hotelSeleccionado') || ''] || null;
      setHotelSeleccionadoId(prev => (prev !== actual ? actual : prev));
    };
    resolverHotelSeleccionado();
    const interval = setInterval(resolverHotelSeleccionado, 1000);
    return () => clearInterval(interval);
  }, [abrevAHotelId]);

  // Con HotelId ya confiable en el resguardo (ver migración 014), ya no hace
  // falta traer TODOS los hoteles del usuario a la vez: si hay un hotel
  // elegido en el nav, solo se piden/filtran los resguardos y activos de ESE
  // hotel. Si no hay ninguno seleccionado (o no resuelve), se cae al
  // comportamiento de siempre (todos los hoteles del usuario).
  const userHotelIds = hotelSeleccionadoId ? [hotelSeleccionadoId] : todosMisHotelIds;

  // Filtrar activos disponibles basados en los HotelIds del usuario
  const filteredActivos = catalogoActivos.filter(activo => {
    // Si el activo tiene propiedad HotelId, verificamos que esté en los permitidos
    // Si no tiene, lo mostramos (depende de tu lógica de negocio)
    return !activo.HotelId || userHotelIds.includes(activo.HotelId);
  });

  // Activos disponibles para agregar al resguardo actual: solo "Activo/Disponible"
  // y que aún no estén asignados a este resguardo.
  const activosDisponiblesParaAgregar = filteredActivos
    .filter(a => a.EstadosId === '1' || a.Estado === 'active')
    .filter(a => !editableActivos.some(ea => ea.Id === a.Id));

  const busquedaNuevoActivoNormalizada = busquedaNuevoActivo.trim().toLowerCase();
  const activosFiltradosPorBusqueda = busquedaNuevoActivoNormalizada
    ? activosDisponiblesParaAgregar.filter(a =>
        a.ActiveName?.toLowerCase().includes(busquedaNuevoActivoNormalizada) ||
        a.SerialNumber?.toLowerCase().includes(busquedaNuevoActivoNormalizada) ||
        a.Modelo?.toLowerCase().includes(busquedaNuevoActivoNormalizada) ||
        a.Folio?.toLowerCase().includes(busquedaNuevoActivoNormalizada)
      )
    : activosDisponiblesParaAgregar;
  const MAX_ACTIVOS_MOSTRADOS = 40;

  const agregarActivoAlResguardo = async (nuevoActivo: Activo) => {
    if (!nuevoActivo || editableActivos.some(a => a.Id === nuevoActivo.Id)) return;

    try {
      // Convertir usuarioNumColab a número
      const usuarioId = selectedResguardo?.usuarioNumColab ?
        parseInt(selectedResguardo.usuarioNumColab) : null;

      // Actualizar el estado del activo a "asignado"
      await activosApi.editar(nuevoActivo.Id.toString(), {
        EstadosId: '2', // ID para estado "Asignado"
      });

      // Agregamos el activo al resguardo
      await resguardosApi.agregarAResguardo({
        ResguardoId: selectedResguardo?.ResguardoId,
        ActivoId: nuevoActivo.Id,
        UsuarioId: usuarioId
      });

    } catch (error) {
      console.error('Error al actualizar estado del activo:', error);
      toast({
        title: "Error",
        description: "No se pudo asignar el activo",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Agregar el activo a la lista local
    setEditableActivos([...editableActivos, nuevoActivo]);
    setHayCambiosPendientes(true);
    setBusquedaNuevoActivo('');

    toast({
      title: "Activo asignado",
      description: `${nuevoActivo.ActiveName} ha sido asignado`,
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  const SignaturePadModal = ({ onSave, onClose }: { onSave: (signature: string) => void, onClose: () => void }) => {
    const sigCanvas = useRef<SignatureCanvas>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 });

    // Actualizar dimensiones cuando el modal se abre
    React.useEffect(() => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.offsetWidth,
          height: 200 // Altura fija que prefieras
        });
      }
    }, []);
    const handleSave = () => {
      if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
        const canvas = sigCanvas.current.getCanvas();
        const imageData = canvas.toDataURL('image/png');

        // Solución para los errores de TypeScript
        const img = document.createElement('img') as HTMLImageElement;
        img.src = imageData;

        img.onload = () => {
          const MAX_WIDTH = 300;
          const scaleFactor = MAX_WIDTH / img.width;
          const newHeight = img.height * scaleFactor;

          const resizedCanvas = document.createElement('canvas');
          resizedCanvas.width = MAX_WIDTH;
          resizedCanvas.height = newHeight;

          const ctx = resizedCanvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0, MAX_WIDTH, newHeight);
            onSave(resizedCanvas.toDataURL('image/png'));
          }
        };
      }
    };

    return (
      <Box position="fixed" top="0" left="0" right="0" bottom="0" bg="rgba(0,0,0,0.5)" zIndex="modal" display="flex" alignItems="center" justifyContent="center">
        <Box bg="white" p="4" borderRadius="md" width="95%" maxW="500px">
          <Text fontSize="lg" mb="4">Firme en el área siguiente</Text>

          {/* Contenedor del canvas */}
          <Box
            ref={containerRef}
            border="1px dashed"
            borderColor="gray.300"
            mb="4"
            width="100%"
            height="200px"
            position="relative"
            bg="white"
          >
            {dimensions.width > 0 && (
              <SignatureCanvas
                ref={sigCanvas}
                penColor="black"
                canvasProps={{
                  width: dimensions.width,
                  height: dimensions.height,
                  style: {
                    width: '100%',
                    height: '100%'
                  }
                }}
              />
            )}
          </Box>

          {/*   <Flex justify="space-between">
            <Button onClick={() => sigCanvas.current?.clear()}>
              Limpiar
            </Button>
            <Button colorScheme="red" onClick={onClose}>
              Cancelar
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSave}
              disabled={sigCanvas.current?.isEmpty()}
            >
              Guardar Firma
            </Button>
          </Flex> */}
        </Box>
      </Box>
    );
  };

  const enviarActivosActualizados = async (
    resguardoId: number,
    activos: Activo[],
    firmaDigital: string,
    esSegundaFirma: boolean = false,
    nuevoEstado?: string,
    correoColaborador?: string,
    soloSupervisor: number = 0 // Nuevo parámetro con valor por defecto 0
  ) => {
    try {
      const colaborador = JSON.parse(sessionStorage.getItem("colaborador") || "{}");
      const dataUser = JSON.parse(sessionStorage.getItem("user") || "{}");

      const body = {
        resguardoId,
        activos: activos.map(a => a.Id),
        firmaDigital,
        colaborador: {
          ...colaborador,
          usuarioDueno: selectedResguardo?.usuarioDueno,
          usuarioNumColab: selectedResguardo?.usuarioNumColab,
          ...(correoColaborador && { email: correoColaborador })
        },
        Rol: dataUser.RolId,
        infoUser: dataUser,
        esSegundaFirma,
        nuevoEstado,
        soloSupervisor // Incluir el indicador en el body
      };

      const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/resguardos/email', {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Error al actualizar los activos y firma');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  // Esta función decide qué filas mostrar
const inverseFilterFn = (row: { getValue: (arg0: any) => any; }, columnId: any, filterValue: { not: any; }) => {
  const cellValue = row.getValue(columnId);

  // Si el filtro es un objeto con la propiedad 'not'
  if (typeof filterValue === 'object' && filterValue !== null && 'not' in filterValue) {
    return cellValue !== filterValue.not; // Mostrar si NO es igual
  }

  // Filtro normal (si hay valor, comparar igualdad; si no, mostrar todo)
  return filterValue ? cellValue === filterValue : true;
};
  // Reemplaza este useEffect actual:
  /* React.useEffect(() => {
    if (selectedResguardo) {
      const activosSeleccionados: Activo[] = selectedResguardo.NombreActivos
        .split(',')
        .map(a => a.trim())
        .map(nombre => catalogoActivos.find(c => c.ActiveName === nombre))
        .filter(Boolean) as Activo[];
      setEditableActivos(activosSeleccionados);
    }
  }, [selectedResguardo, catalogoActivos]); */

  // Por este nuevo useEffect que se ejecuta cuando se abre el drawer:
  React.useEffect(() => {
    const cargarDatosDelResguardo = async () => {
      if (selectedResguardo && isDrawerOpen) {
        try {
          setIsLoadingDrawer(true);
          // Limpiar activos anteriores
          setEditableActivos([]);
          setDepartamentoHistorico(null);

          const esCancelado = selectedResguardo.Estado === 'CANCELADO';

          // Si ya está cancelado, se usa el snapshot congelado al momento de la cancelación
          // en vez del JOIN en vivo, para que cambios posteriores en los activos/departamentos
          // (incluido el departamento del dueño) no alteren lo que ya se canceló.
          const [historicoOActivos, catalogoActualizado] = await Promise.all([
            esCancelado
              ? resguardosApi.obtenerHistorico(selectedResguardo.ResguardoId)
              : resguardosApi.obtenerActivosPorResguardo(selectedResguardo.ResguardoId),
            activosApi.listado()
          ]);

          const activosDelResguardo = esCancelado ? (historicoOActivos?.activos || []) : historicoOActivos;

          if (esCancelado) {
            setDepartamentoHistorico(historicoOActivos?.resguardo?.usuarioDepartamento || null);
          }

          setCatalogoActivos(catalogoActualizado);

          // Mapear activos del resguardo
          const activosMapeados: Activo[] = activosDelResguardo.map((activo: { Id: any; Activo: any; SerialNumber: any; Modelo: any; QR: any; Estado: any; Hotel: any; Usuario: any; }) => ({
            Id: activo.Id,
            ActiveName: activo.Activo,
            SerialNumber: activo.SerialNumber,
            Modelo: activo.Modelo,
            Inventario: activo.QR,
            EstadosId: activo.Estado,
            HotelId: activo.Hotel,
            activoDueno: activo.Usuario
          }));

          setEditableActivos(activosMapeados);

        } catch (error) {
          console.error('Error al cargar datos del resguardo:', error);
        } finally {
          setIsLoadingDrawer(false);
        }
      }
    };

    cargarDatosDelResguardo();
  }, [selectedResguardo, isDrawerOpen]);
  React.useEffect(() => {
    const fetchActivos = async () => {
      const activos = await activosApi.listado();
      setCatalogoActivos(activos);
    };
    fetchActivos();
  }, []);

  const [{ pageIndex, pageSize }, setPagination] = React.useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const searchUsuarioNumColab = (location.state as any)?.searchUsuarioNumColab;
    if (searchUsuarioNumColab) {
      setGlobalFilter(String(searchUsuarioNumColab));
      navigate(location.pathname, { replace: true, state: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);

  const textColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const brandColor = useColorModeValue('brand.500', 'brand.400');
  const listaActivosInputBg = useColorModeValue('white', 'gray.800');
  const listaActivosBorderColor = useColorModeValue('gray.100', 'gray.600');
  const listaActivosHoverBg = useColorModeValue('blue.50', 'gray.600');
  const modoFirmaSeleccionadoBg = useColorModeValue('blue.50', 'blue.900');
  const modoFirmaCardBg = useColorModeValue('white', 'gray.800');

  const columnHelper = createColumnHelper<RowObj>();

  const columns = [
    columnHelper.accessor('name', {
      id: 'name',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>
          COLABORADOR
        </Text>
      ),
      cell: (info) => (
        <Flex align='center'>
          <Avatar src={info.getValue()[1]} h='50px' w='50px' me='10px' display={{ base: 'none', md: 'block' }} />
          <Box>
            <Text color={textColor} fontSize='sm' fontWeight='500'>
              {info.getValue()[0]}
            </Text>
            <Text fontSize='xs' color='gray.500' display={{ base: 'none', lg: 'block' }}>
              ID: {info.row.original.ResguardoId} • N°: {info.row.original.usuarioNumColab}
            </Text>
            <Text fontSize='xs' color='gray.500' display={{ base: 'block', lg: 'none' }}>
              Depto: {info.row.original.departamento}
            </Text>
          </Box>
        </Flex>
      ),
    }),
    columnHelper.accessor('departamento', {
      id: 'departamento',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400' display={{ base: 'none', lg: 'block' }}>
          DEPARTAMENTO DEL DUEÑO
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize='sm' fontWeight='500' display={{ base: 'none', lg: 'block' }}>
          {info.row.original.departamentoColaborador || info.getValue()}
        </Text>
      ),
    }),
    columnHelper.accessor('fechaInicio', {
      id: 'fechaInicio',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400' display={{ base: 'none', md: 'block' }}>
          FECHA
        </Text>
      ),
      cell: (info) => (
        <Box display={{ base: 'none', md: 'block' }}>
          <Text color={textColor} fontSize='sm' fontWeight='500'>
            {new Date(info.getValue()).toLocaleDateString()}
          </Text>
          <Text fontSize='xs' color='gray.500' display={{ base: 'none', lg: 'block' }}>
            {new Date(info.getValue()).toLocaleTimeString()}
          </Text>
        </Box>
      ),
    }),
    columnHelper.accessor('Estado', {
      id: 'Estado',
      filterFn: inverseFilterFn, // <--- Agrega esto aquí
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>
          ESTADO
        </Text>
      ),
      cell: (info) => {
        const value = info.getValue();
        const colorSchemeMap: Record<string, string> = {
          "Borrador": "gray",
          "Proceso de autorización": "blue",
          "Autorizado": "purple",
          "Pendiente de firma del colaborador": "yellow",
          "Recepción confirmada": "green",
          "ACTIVO": "green",
          "ASIGNADO": "blue",
          "PENDIENTE": "yellow",
          "INACTIVO": "red",
          "EN GARANTÍA": "purple",
          "EN MANTENIMIENTO": "orange",
          "EN REPARACIÓN": "pink",
          "RMA": "cyan",
          "CANCELADO": "red", // Color distintivo para cancelados
        };

        const color = colorSchemeMap[value] ? `${colorSchemeMap[value]}.500` : "gray.500";

        return (
          <Badge
            colorScheme={colorSchemeMap[value] || "gray"}
            color={color}
            fontSize="sm"
            fontWeight="500"
            px="2"
            py="1"
            borderRadius="md"
          >
            {value}
          </Badge>
        );
      },
    }),
    columnHelper.accessor('NombreActivos', {
      id: 'activos',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400' display={{ base: 'none', lg: 'block' }}>
          ACTIVOS
        </Text>
      ),
      cell: (info) => {
        const activos = info.getValue();
        const cantidadActivos = activos ? activos.split(',').length : 0;

        return (
          <Box display={{ base: 'none', lg: 'block' }}>
            <Text color={textColor} fontSize='sm' fontWeight='500'>
              {cantidadActivos} activo{cantidadActivos !== 1 ? 's' : ''}
            </Text>
            {activos && (
              <Text fontSize='xs' color='gray.500' noOfLines={1} maxW="120px">
                {activos.split(',').slice(0, 1).join(', ')}
                {cantidadActivos > 1 && ` +${cantidadActivos - 1}`}
              </Text>
            )}
          </Box>
        );
      },
    }),
    columnHelper.display({
      id: 'acciones',
      header: () => (
        <Text fontSize={{ sm: '10px', lg: '12px' }} color='gray.400'>
          ACCIONES
        </Text>
      ),
      cell: (info) => (
        <Flex gap="2">
          <Tooltip label="Ver detalle" fontSize="xs">
            <IconButton
              aria-label="Ver detalle"
              icon={<Icon as={MdVisibility} w='20px' h='20px' />}
              size="lg"
              variant="ghost"
              colorScheme="gray"
              onClick={() => {
                setEditableActivos([]);
                setCorreoColaborador('');
                setModoFirma(null);
                setEnviarCopiaCorreos(false);
                setCopiaCorreosInput('');
                setMensajePersonalizadoCorreo('');
                if (sigCanvas.current) {
                  sigCanvas.current.clear();
                }
                setSelectedResguardo(info.row.original);
                onOpenDrawer();
              }}
            />
          </Tooltip>
          {info.row.original.Estado === "Recepción confirmada" && (
            <Tooltip label="Descargar PDF" fontSize="xs">
              <IconButton
                aria-label="Descargar PDF"
                icon={<Icon as={MdDownload} w='20px' h='20px' />}
                size="lg"
                variant="ghost"
                colorScheme="teal"
                onClick={(e) => {
                  e.stopPropagation();
                  descargarPDF(info.row.original.ResguardoId);
                }}
              />
            </Tooltip>
          )}
          {!isSoloLectura() && ["Recepción confirmada", "Autorizado"].includes(info.row.original.Estado) && (
            <Tooltip label="Cancelar resguardo" fontSize="xs">
              <IconButton
                aria-label="Cancelar resguardo"
                icon={<Icon as={MdCancel} w='20px' h='20px' />}
                size="lg"
                variant="ghost"
                colorScheme="red"
                onClick={(e) => {
                  e.stopPropagation();
                  setEditableActivos([]);
                  setCorreoColaborador('');
                  setModoFirma(null);
                  setEnviarCopiaCorreos(false);
                  setCopiaCorreosInput('');
                  setMensajePersonalizadoCorreo('');
                  if (sigCanvas.current) {
                    sigCanvas.current.clear();
                  }
                  setSelectedResguardo(info.row.original);
                  onOpenDrawer();
                  setMotivoCancelacion('');
                  setShowCancelAlert(true);
                }}
              />
            </Tooltip>
          )}
        </Flex>
      ),
    }),
  ];
  // Agrega esta función antes de la definición de la tabla
// Quita espacios y guiones para que "AB-1234" y "ab 1234" encuentren el mismo folio/serie.
const normalizarCodigo = (valor: string) => valor.toLowerCase().replace(/[\s-]/g, '');

const globalFilterFn = (row: any, columnId: string, filterValue: string) => {
  const s = filterValue.toLowerCase().trim();
  const sCodigo = normalizarCodigo(filterValue);
  const { usuarioDueno, departamento, Estado, ResguardoId, NombreActivos, usuarioNumColab, SerialNumbers, Folios } = row.original;

  return (
    usuarioDueno?.toLowerCase().includes(s) ||
    departamento?.toLowerCase().includes(s) ||
    Estado?.toLowerCase().includes(s) ||
    ResguardoId?.toString().includes(s) ||
    NombreActivos?.toLowerCase().includes(s) ||
    usuarioNumColab?.toString().includes(s) ||
    (SerialNumbers && normalizarCodigo(SerialNumbers).includes(sCodigo)) ||
    (Folios && normalizarCodigo(Folios).includes(sCodigo))
  );
};


  // Función para verificar y manejar la eliminación del resguardo cuando no hay activos
  const verificarYEliminarResguardo = async (nuevosActivos: Activo[]) => {
    if (nuevosActivos.length === 0 && editableActivos.length > 0) {
      // Guardar backup de los activos antes de mostrar la alerta
      setLastActivosBackup([...editableActivos]);
      // Mostrar alerta central
      setShowDeleteAlert(true);
    }
  };

  // Función para cancelar la eliminación y restaurar activos
  const cancelarEliminacion = () => {
    // Restaurar los activos desde el backup
    setEditableActivos(lastActivosBackup);
    setShowDeleteAlert(false);
    setLastActivosBackup([]);

    toast({
      title: "Acción cancelada",
      description: "Los activos han sido restaurados",
      status: "info",
      duration: 2000,
      isClosable: true,
    });
  };

  // Función para eliminar el resguardo completamente
  // Función para eliminar el resguardo completamente
  const eliminarResguardoCompletamente = async () => {
    if (!selectedResguardo) return;

    try {
      // Si hay un último activo en el backup, desasignarlo primero
      if (lastActivosBackup.length === 1) {
        const ultimoActivo = lastActivosBackup[0];

        // 1. Cambiar el estado del activo a "Activo"
        await activosApi.editar(ultimoActivo.Id.toString(), {
          EstadosId: '1', // Estado "Activo"
        });

        // 2. Quitar el activo del resguardo en la base de datos
        await resguardosApi.quitarDeResguardo(
          selectedResguardo.ResguardoId,
          ultimoActivo.Id
        );
      }

      // 3. Llamar a la API para eliminar el resguardo
      await resguardosApi.eliminar(selectedResguardo.ResguardoId);

      // Mostrar notificación de éxito
      toast({
        title: "Resguardo eliminado",
        description: "El resguardo ha sido eliminado correctamente",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // Cerrar el drawer y limpiar estados
      setShowDeleteAlert(false);
      setLastActivosBackup([]);
      setEditableActivos([]); // Limpiar los activos editables
      onCloseDrawer();

      // Recargar la lista de resguardos
      const res = await resguardosApi.listadoId(userHotelIds);
      const formattedData = await construirFilasResguardos(res);
      setData(formattedData);

    } catch (error) {
      console.error('Error al eliminar el resguardo:', error);
      toast({
        title: "Error",
        description: "No se pudo eliminar el resguardo",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const desasignarActivo = async () => {
    if (editableActivos.length === 0) return;

    const ultimoActivo = editableActivos[editableActivos.length - 1];

    // Verificar si solo queda un activo
    if (editableActivos.length === 1) {
      setShowUnicoActivoAlert(true);
      return;
    }

    try {
      // 1. Cambiar el estado del activo a "Activo"
      await activosApi.editar(ultimoActivo.Id.toString(), {
        EstadosId: '1', // Estado "Activo"
      });

      // 2. Quitar el activo del resguardo en la base de datos
      await resguardosApi.quitarDeResguardo(
        selectedResguardo?.ResguardoId || 0,
        ultimoActivo.Id
      );

      // 3. Actualizar la lista de activos en el estado
      const nuevosActivos = editableActivos.slice(0, -1);
      setEditableActivos(nuevosActivos);

      toast({
        title: "Activo desasignado",
        description: `${ultimoActivo.ActiveName} ha sido desasignado correctamente`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

    } catch (error) {
      console.error('Error al desasignar el activo:', error);
      toast({
        title: "Error",
        description: "No se pudo desasignar el activo",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }

  const confirmarDesasignacionUnicoActivo = async () => {
    if (editableActivos.length === 0 || !selectedResguardo) return;

    const ultimoActivo = editableActivos[0]; // Solo hay un activo

    try {
      // 1. Cambiar el estado del activo a "Activo"
      await activosApi.editar(ultimoActivo.Id.toString(), {
        EstadosId: '1', // Estado "Activo"
      });

      // 2. Quitar el activo del resguardo en la base de datos
      await resguardosApi.quitarDeResguardo(
        selectedResguardo.ResguardoId,
        ultimoActivo.Id
      );

      // 3. Mostrar alerta de que el resguardo quedará inactivo
      setLastActivosBackup([...editableActivos]);
      setShowDeleteAlert(true);

      // 4. Cerrar la alerta del único activo
      setShowUnicoActivoAlert(false);

      toast({
        title: "Último activo desasignado",
        description: `${ultimoActivo.ActiveName} ha sido desasignado. El resguardo quedará inactivo.`,
        status: "warning",
        duration: 3000,
        isClosable: true,
      });

    } catch (error) {
      console.error('Error al desasignar el último activo:', error);
      toast({
        title: "Error",
        description: "No se pudo desasignar el activo",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  // Luego en la configuración de la tabla:
  const table = useReactTable({
    data,
    columns,
    state: {
      columnFilters,
      globalFilter,
      pagination
    },
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    globalFilterFn: globalFilterFn, // Usa la función personalizada
  });
  const createPages = (count: number) => {
    return Array.from({ length: count }, (_, i) => i + 1);
  };



  React.useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await resguardosApi.listadoId(userHotelIds);
        if (res && res.length > 0) console.log('[DEBUG resguardos] keys del primer item:', Object.keys(res[0]), res[0]);
        const formattedData = await construirFilasResguardos(res);
        setData(formattedData);
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // Se vuelve a pedir la lista cuando cambia el hotel elegido en el nav.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotelSeleccionadoId]);

  const cancelarResguardo = async () => {
    if (window.confirm("¿Estás seguro de que deseas cancelar este resguardo?")) {
      try {
        // Tu llamada a la API aquí
        // await resguardosApi.cancelar(selectedResguardo.ResguardoId);
        toast({
          title: "Resguardo cancelado",
          status: "info",
          duration: 3000,
        });
        onCloseDrawer();
        actualizarListaResguardos();
      } catch (error) {
        console.error(error);
      }
    }
  };
  return (
    <Flex direction='column' w='100%' overflowX={{ sm: 'scroll', lg: 'hidden' }}>
{/* Barra de Herramientas de Filtros */}
{/* Barra de Herramientas de Filtros */}
<Stack direction="column" spacing="4" px="25px" mb="25px">
  <Flex justify="space-between" align="center" wrap="wrap" gap="4">
    {/* Buscador Inteligente */}
    <Box position="relative" w={{ base: 'full', md: '400px' }}>
      <Input
        placeholder="Buscar por nombre, folio, No. serie, departamento o No. colaborador..."
        value={globalFilter ?? ''}
        onChange={(e) => setGlobalFilter(String(e.target.value))}
        size="md"
        pl="40px"
        borderRadius="12px"
        bg={useColorModeValue('white', 'gray.800')}
        border="1px solid"
        borderColor="gray.200"
        _focus={{ borderColor: 'brand.500', boxShadow: 'none' }}
      />
      <Icon 
        as={MdRefresh} 
        position="absolute" 
        left="15px" 
        top="50%" 
        transform="translateY(-50%)" 
        color="gray.400"
      />
    </Box>

    {!isSoloLectura() && (
      <Button
        leftIcon={<MdAdd />}
        colorScheme="brand"
        borderRadius="12px"
        onClick={() => navigate('/admin/main/ecommerce/order-details')}
      >
        Crear Resguardo
      </Button>
    )}
  </Flex>

  {/* Filtros de Estado */}
{/* Filtros de Estado */}
<Flex gap="2" overflowX="auto" pb="2" sx={{
  '&::-webkit-scrollbar': { display: 'none' },
  '-ms-overflow-style': 'none',
  'scrollbar-width': 'none',
}}>
  {[
    { label: 'Todos', value: 'TODOS', color: 'gray' },
    { label: 'Borrador', value: 'Borrador', color: 'gray' },
    { label: 'En Autorización', value: 'Proceso de autorización', color: 'blue' },
    { label: 'Autorizado', value: 'Autorizado', color: 'purple' },
    { label: 'Firma Remota', value: 'Pendiente de firma del colaborador', color: 'yellow' },
    { label: 'Confirmados', value: 'Recepción confirmada', color: 'green' },
    { label: 'Cancelados', value: 'CANCELADO', color: 'red' }
  ].map((status) => {
    // Buscamos si hay un filtro activo para "Estado"
    const currentFilter = columnFilters.find(f => f.id === 'Estado');
    const filterValue = currentFilter?.value;

    // Lógica de visualización:
    // Si el valor es idéntico, es filtro normal. 
    // Si el valor es un objeto con {not: ...}, es el filtro invertido.
    const isNormalMatch = filterValue === status.value;
    const isInverseMatch = typeof filterValue === 'object' && filterValue !== null && (filterValue as any).not === status.value;

    return (
      <Button
        key={status.value}
        size="sm"
        // Cambiamos el estilo visual si está "tachado" (invertido)
        variant={isNormalMatch || isInverseMatch ? 'solid' : 'outline'}
        colorScheme={status.color}
        textDecoration={isInverseMatch ? 'line-through' : 'none'}
        opacity={isInverseMatch ? 0.7 : 1}
        onClick={() => {
          if (status.value === 'TODOS') {
            setColumnFilters([]);
            return;
          }

          setColumnFilters(prev => {
            const existing = prev.find(f => f.id === 'Estado');
            
            // Si no hay filtro, poner el normal
            if (!existing || existing.value !== status.value) {
              if (isInverseMatch) {
                 // Si ya estaba invertido y picas de nuevo, lo limpiamos
                 return prev.filter(f => f.id !== 'Estado');
              }
              return [{ id: 'Estado', value: status.value }];
            }

            // Si ya es el normal, cambiar a INVERTIDO (not)
            if (existing.value === status.value) {
              return [{ id: 'Estado', value: { not: status.value } }];
            }

            return [];
          });
        }}
        borderRadius="full"
        px="4"
        fontSize="xs"
        flexShrink={0}
      >
        {isInverseMatch ? `No ${status.label}` : status.label}
      </Button>
    );
  })}
</Flex>
</Stack>

      <Table variant='simple' color='gray.500' mb='24px'>
        <Thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <Tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <Th key={header.id} borderColor={borderColor}>
                  {header.isPlaceholder ? null : (
                    <Flex
                      className={header.column.getCanSort() ? 'cursor-pointer select-none' : ''}
                      onClick={header.column.getToggleSortingHandler()}
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.400'
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                    </Flex>
                  )}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {isLoading
            ? Array.from({ length: 8 }).map((_, i) => (
                <Tr key={`skeleton-${i}`}>
                  {columns.map((_, j) => (
                    <Td key={j} borderColor={borderColor} py="14px">
                      <Skeleton height="18px" borderRadius="md" startColor="gray.100" endColor="gray.200" />
                    </Td>
                  ))}
                </Tr>
              ))
            : table.getRowModel().rows.map((row, index) => (
                <MotionTr
                  key={row.id}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.25,
                    delay: index * 0.035,
                    ease: [0.16, 1, 0.3, 1],
                  }}
                >
                  {row.getVisibleCells().map((cell) => (
                    <Td key={cell.id} fontSize='14px' borderColor={borderColor}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </Td>
                  ))}
                </MotionTr>
              ))
          }
        </Tbody>
      </Table>

      <Flex w='100%' justify='space-between' align='center' px='20px' pt='10px' pb='5px' direction={{ base: 'column', md: 'row' }} gap={4}>
        {/* Info + selector de tamaño */}
        <Flex align='center' gap={3}>
          <Text fontSize='sm' color='gray.500' whiteSpace='nowrap'>
            {table.getFilteredRowModel().rows.length === 0
              ? 'Sin resultados'
              : `${pageIndex * pageSize + 1}–${Math.min((pageIndex + 1) * pageSize, table.getFilteredRowModel().rows.length)} de ${table.getFilteredRowModel().rows.length}`}
          </Text>
          <Select
            fontSize='sm'
            size='sm'
            borderRadius='md'
            borderColor={borderColor}
            value={pageSize}
            onChange={(e) => table.setPageSize(Number(e.target.value))}
            width='100px'
          >
            {[10, 20, 30, 50].map((num) => (
              <option key={num} value={num}>Ver {num}</option>
            ))}
          </Select>
        </Flex>

        {/* Controles de paginación */}
        <Flex align='center' gap='4px'>
          <Button
            variant='outline'
            onClick={() => table.previousPage()}
            isDisabled={!table.getCanPreviousPage()}
            w='36px' h='36px'
            borderRadius='50%'
            borderColor={borderColor}
            _hover={{ bg: useColorModeValue('gray.100', 'whiteAlpha.100') }}
          >
            <Icon as={MdChevronLeft} w='16px' h='16px' color={textColor} />
          </Button>

          {Array.from({ length: table.getPageCount() }, (_, index) => {
            const total = table.getPageCount();
            const showPage =
              index === 0 ||
              index === total - 1 ||
              (index >= pageIndex - 1 && index <= pageIndex + 1);

            if (showPage) {
              return (
                <Button
                  key={index}
                  onClick={() => table.setPageIndex(index)}
                  variant={pageIndex === index ? 'solid' : 'outline'}
                  colorScheme={pageIndex === index ? 'blue' : 'gray'}
                  w='36px' h='36px'
                  borderRadius='50%'
                  fontSize='sm'
                  minW='36px'
                >
                  {index + 1}
                </Button>
              );
            }

            if (index === 1 || index === total - 2) {
              return (
                <Text key={index} px={1} color='gray.400' fontSize='sm' userSelect='none'>
                  …
                </Text>
              );
            }

            return null;
          })}

          <Button
            variant='outline'
            onClick={() => table.nextPage()}
            isDisabled={!table.getCanNextPage()}
            w='36px' h='36px'
            borderRadius='50%'
            borderColor={borderColor}
            _hover={{ bg: useColorModeValue('gray.100', 'whiteAlpha.100') }}
          >
            <Icon as={MdChevronRight} w='16px' h='16px' color={textColor} />
          </Button>
        </Flex>
      </Flex>


      <Drawer isOpen={isDrawerOpen} placement="right" onClose={onCloseDrawer} size="md">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottom='1px' borderColor={borderColor}>
            <Flex direction="column">
              <Text fontSize="xl" fontWeight="bold">Detalles del Resguardo</Text>
              <Badge
                colorScheme={
                  selectedResguardo?.Estado === "Borrador" ? "gray" :
                    selectedResguardo?.Estado === "Proceso de autorización" ? "blue" :
                      selectedResguardo?.Estado === "Autorizado" ? "purple" :
                        selectedResguardo?.Estado === "Pendiente de firma del colaborador" ? "yellow" :
                          selectedResguardo?.Estado === "Recepción confirmada" ? "green" :
                            selectedResguardo?.Estado === "ACTIVO" ? "green" :
                              selectedResguardo?.Estado === "ASIGNADO" ? "blue" :
                                selectedResguardo?.Estado === "PENDIENTE" ? "yellow" :
                                  selectedResguardo?.Estado === "INACTIVO" ? "red" :
                                    selectedResguardo?.Estado === "EN GARANTÍA" ? "purple" :
                                      selectedResguardo?.Estado === "EN MANTENIMIENTO" ? "orange" :
                                        selectedResguardo?.Estado === "EN REPARACIÓN" ? "pink" :
                                          selectedResguardo?.Estado === "RMA" ? "cyan" : "gray"
                }
                color={
                  selectedResguardo?.Estado === "Borrador" ? "gray" :
                    selectedResguardo?.Estado === "Proceso de autorización" ? "blue.500" :
                      selectedResguardo?.Estado === "Autorizado" ? "purple.500" :
                        selectedResguardo?.Estado === "Pendiente de firma del colaborador" ? "yellow.500" :
                          selectedResguardo?.Estado === "Recepción confirmada" ? "green.500" :
                            selectedResguardo?.Estado === "ACTIVO" ? "green.500" :
                              selectedResguardo?.Estado === "ASIGNADO" ? "blue.500" :
                                selectedResguardo?.Estado === "PENDIENTE" ? "yellow.500" :
                                  selectedResguardo?.Estado === "INACTIVO" ? "red.500" :
                                    selectedResguardo?.Estado === "EN GARANTÍA" ? "purple.500" :
                                      selectedResguardo?.Estado === "EN MANTENIMIENTO" ? "orange.500" :
                                        selectedResguardo?.Estado === "EN REPARACIÓN" ? "pink.500" :
                                          selectedResguardo?.Estado === "RMA" ? "cyan.500" : "gray.500"
                }
                mt="2"
                fontSize="0.8em"
                alignSelf="flex-start"
              >
                {selectedResguardo?.Estado}
              </Badge>
            </Flex>
          </DrawerHeader>

          <DrawerBody p="20px">

            {selectedResguardo?.Estado === "CANCELADO" && (
              <Box
                bg="red.50"
                p={4}
                borderRadius="lg"
                mb={6}
                border="1px solid"
                borderColor="red.200"
              >
                <Flex align="center">
                  <Icon as={MdCancel} color="red.500" w={5} h={5} mr={3} />
                  <Box>
                    <Text color="red.700" fontWeight="bold" fontSize="sm">
                      RESGUARDO CANCELADO (HISTORIAL)
                    </Text>
                    <Text fontSize="xs" color="red.600">
                      Los activos han sido liberados. Este registro se mantiene solo para fines de auditoría.
                    </Text>
                    {selectedResguardo?.Motivo && (
                      <Text fontSize="xs" color="red.700" mt={1}>
                        <strong>Motivo:</strong> {selectedResguardo.Motivo}
                      </Text>
                    )}
                  </Box>
                </Flex>
              </Box>
            )}

            {showDeleteAlert && (
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                bg="white"
                p={6}
                borderRadius="lg"
                boxShadow="2xl"
                zIndex="modal"
                border="2px solid"
                borderColor="red.200"
                minW="400px"
                textAlign="center"
              >
                <Flex direction="column" align="center">
                  <Box color="red.500" mb={3}>
                    <Icon as={MdWarning} w={12} h={12} />
                  </Box>
                  <Heading size="md" color="red.600" mb={2}>
                    Resguardo sin activos
                  </Heading>
                  <Text color="gray.600" mb={4}>
                    Se han quitado todos los activos de este resguardo.
                    <br />
                    <Text as="span" fontWeight="bold">
                      ¿Desea eliminar el resguardo completamente?
                    </Text>
                  </Text>
                  <Flex gap={3} justify="center">
                    <Button
                      colorScheme="red"
                      onClick={eliminarResguardoCompletamente}
                      leftIcon={<MdDelete />}
                    >
                      Sí, eliminar
                    </Button>
                    <Button
                      variant="outline"
                      onClick={cancelarEliminacion}
                      leftIcon={<MdUndo />}
                    >
                      Cancelar y restaurar
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            )}

            {showDesasignarActivo && (
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                bg="white"
                p={6}
                borderRadius="lg"
                boxShadow="2xl"
                zIndex="modal"
                border="2px solid"
                borderColor="red.200"
                minW="400px"
                textAlign="center"
              >
                <Flex direction="column" align="center">
                  <Box color="red.500" mb={3}>
                    <Icon as={MdWarning} w={12} h={12} />
                  </Box>
                  <Heading size="md" color="red.600" mb={2}>
                    Estas a punto de desasignar un activo
                  </Heading>
                  <Text color="gray.600" mb={4}>
                    Se notificará al colaborador por correo con los detalles y su nuevo resguardo autorizado.
                    <br />
                    <Text as="span" fontWeight="bold">
                      ¿Deseas confirmar la desasignación del activo?
                    </Text>
                  </Text>
                  <Flex gap={3} justify="center">
                    <Button
                      colorScheme="red"
                      onClick={desasignarActivo}
                      leftIcon={<MdDelete />}
                    >
                      Sí, eliminar
                    </Button>
                    <Button
                      variant="outline"
                      onClick={cancelarEliminacion}
                      leftIcon={<MdUndo />}
                    >
                      Cancelar y restaurar
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            )}

            {showDesasignarActivoAviso && (
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                bg="white"
                p={6}
                borderRadius="lg"
                boxShadow="2xl"
                zIndex="modal"
                border="2px solid"
                borderColor="red.200"
                minW="400px"
                textAlign="center"
              >
                <Flex direction="column" align="center">
                  <Box color="red.500" mb={3}>
                    <Icon as={MdWarning} w={12} h={12} />
                  </Box>
                  <Heading size="md" color="red.600" mb={2}>
                    Desasignar {activosSeleccionados.length} activo(s)
                  </Heading>
                  <Text color="gray.600" mb={4}>
                    Se notificará al colaborador por correo con los detalles y su nuevo resguardo autorizado.
                    <br />
                    <Text as="span" fontWeight="bold">
                      ¿Deseas confirmar la desasignación de {activosSeleccionados.length} activo(s)?
                    </Text>
                  </Text>
                  <Flex gap={3} justify="center">
                    <Button
                      colorScheme="red"
                      onClick={confirmarDesasignacionMultiple}
                      leftIcon={<MdDelete />}
                    >
                      Sí, desasignar ({activosSeleccionados.length})
                    </Button>
                    <Button
                      variant="outline"
                      onClick={cancelarDesasignacion}
                      leftIcon={<MdUndo />}
                    >
                      Cancelar
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            )}

            {showUnicoActivoAlert && (
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                bg="white"
                p={6}
                borderRadius="lg"
                boxShadow="2xl"
                zIndex="modal"
                border="2px solid"
                borderColor="orange.200"
                minW="400px"
                textAlign="center"
              >
                <Flex direction="column" align="center">
                  <Box color="orange.500" mb={3}>
                    <Icon as={MdWarning} w={12} h={12} />
                  </Box>
                  <Heading size="md" color="orange.600" mb={2}>
                    Último activo en el resguardo
                  </Heading>
                  <Text color="gray.600" mb={4}>
                    Estás a punto de desasignar el último activo de este resguardo.
                    <br />
                    <Text as="span" fontWeight="bold">
                      El resguardo se marcará como inactivo porque no cuenta con activos.
                    </Text>
                    <br />
                    <Text fontSize="sm" mt={2}>
                      Activo: {editableActivos[0]?.ActiveName}
                    </Text>
                  </Text>
                  <Flex gap={3} justify="center">
                    <Button
                      colorScheme="orange"
                      onClick={confirmarDesasignacionUnicoActivo}
                      leftIcon={<MdDelete />}
                    >
                      Sí, desasignar último activo
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setShowUnicoActivoAlert(false)}
                      leftIcon={<MdUndo />}
                    >
                      Cancelar
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            )}

            {selectedResguardo && (
              <Stack spacing="20px">
                <Flex align="center">
                  <Avatar src={selectedResguardo.name[1]} size="xl" me="15px" />
                  <Box>
                    <Text fontSize="lg" fontWeight="bold">{selectedResguardo.usuarioDueno}</Text>
                    <Text fontSize="sm" color="gray.500">
                      No. Colaborador: {selectedResguardo.usuarioNumColab}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      ID Resguardo: {selectedResguardo.ResguardoId}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      Email colaborador: {selectedResguardo.emailAsociado_resguardo || 'N/A'}
                    </Text>
                  </Box>
                </Flex>

                <Divider />

                <SimpleGrid columns={2} spacing={4}>
                  <Box>
                    <Text fontSize="sm" color="gray.500">Departamento</Text>
                    <Text fontWeight="medium">{departamentoHistorico ?? (selectedResguardo.departamentoColaborador || selectedResguardo.departamento)}</Text>
                  </Box>
                  <Box>
                    <Text fontSize="sm" color="gray.500">Fecha de Inicio</Text>
                    <Text fontWeight="medium">
                      {new Date(selectedResguardo.CreatedDate).toLocaleDateString()}
                    </Text>
                  </Box>
                  <Box>
                    <Text fontSize="sm" color="gray.500">Estado</Text>
                    <Text fontWeight="medium">
                      <Badge
                        colorScheme={
                          selectedResguardo?.Estado === "Borrador" ? "gray" :
                            selectedResguardo?.Estado === "Proceso de autorización" ? "blue" :
                              selectedResguardo?.Estado === "Autorizado" ? "purple" :
                                selectedResguardo?.Estado === "Pendiente de firma del colaborador" ? "yellow" :
                                  selectedResguardo?.Estado === "Recepción confirmada" ? "green" :
                                    selectedResguardo?.Estado === "ACTIVO" ? "green" :
                                      selectedResguardo?.Estado === "ASIGNADO" ? "blue" :
                                        selectedResguardo?.Estado === "PENDIENTE" ? "yellow" :
                                          selectedResguardo?.Estado === "INACTIVO" ? "red" :
                                            selectedResguardo?.Estado === "EN GARANTÍA" ? "purple" :
                                              selectedResguardo?.Estado === "EN MANTENIMIENTO" ? "orange" :
                                                selectedResguardo?.Estado === "EN REPARACIÓN" ? "pink" :
                                                  selectedResguardo?.Estado === "RMA" ? "cyan" : "gray"
                        }
                        color={
                          selectedResguardo?.Estado === "Borrador" ? "gray" :
                            selectedResguardo?.Estado === "Proceso de autorización" ? "blue.500" :
                              selectedResguardo?.Estado === "Autorizado" ? "purple.500" :
                                selectedResguardo?.Estado === "Pendiente de firma del colaborador" ? "yellow.500" :
                                  selectedResguardo?.Estado === "Recepción confirmada" ? "green.500" :
                                    selectedResguardo?.Estado === "ACTIVO" ? "green.500" :
                                      selectedResguardo?.Estado === "ASIGNADO" ? "blue.500" :
                                        selectedResguardo?.Estado === "PENDIENTE" ? "yellow.500" :
                                          selectedResguardo?.Estado === "INACTIVO" ? "red.500" :
                                            selectedResguardo?.Estado === "EN GARANTÍA" ? "purple.500" :
                                              selectedResguardo?.Estado === "EN MANTENIMIENTO" ? "orange.500" :
                                                selectedResguardo?.Estado === "EN REPARACIÓN" ? "pink.500" :
                                                  selectedResguardo?.Estado === "RMA" ? "cyan.500" : "gray.500"
                        }
                        mt="2"
                        fontSize="0.8em"
                        alignSelf="flex-start"
                      >
                        {selectedResguardo?.Estado}
                      </Badge>
                    </Text>
                  </Box>
                  <Box>
                    <Text fontSize="sm" color="gray.500">Motivo</Text>
                    <Text fontWeight="medium">{selectedResguardo.Motivo || 'N/A'}</Text>
                  </Box>

                </SimpleGrid>

                {/* Formulario de autorización (correo + firma) cuando un supervisor/admin
                    autoriza directo un resguardo en Borrador. Va arriba, justo después del
                    resumen, para que se vea sin tener que bajar toda la pantalla — es la
                    razón principal por la que se abrió este drawer en este estado. El botón
                    que dispara la acción vive en el DrawerFooter, junto a Cerrar. */}
                {!isSoloLectura() && selectedResguardo?.Estado === "Borrador" && editableActivos.length > 0 && (() => {
                  const userData = JSON.parse(sessionStorage.getItem("user") || "{}");
                  const esSupervisor = userData.RolId !== 3;
                  const firmaRegistrada = userData.Firma && userData.Firma.toLowerCase() !== 'sin firma registrada'
                    ? userData.Firma : null;
                  const usarFirmaRegistrada = firmaRegistrada && !usarNuevaFirmaAutorizacion;

                  return esSupervisor && (
                    <Box
                      p={4}
                      border="1px solid"
                      borderColor={borderColor}
                      borderRadius="lg"
                      bg={modoFirmaCardBg}
                    >
                      <Flex align="center" gap={2} mb={3}>
                        <Icon as={MdVerifiedUser} color="blue.500" boxSize={5} />
                        <Text fontSize="md" fontWeight="bold">Autorización</Text>
                      </Flex>

                      <Flex
                        align="start"
                        gap={2}
                        mb={4}
                        p={3}
                        bg={modoFirmaSeleccionadoBg}
                        borderRadius="md"
                      >
                        <Icon as={MdInfoOutline} color="blue.500" boxSize={4} mt="2px" flexShrink={0} />
                        <Text fontSize="xs" color="gray.600">
                          Al autorizar, el resguardo se salta la revisión, pero la persona que
                          recibirá los activos todavía tendrá que firmar después (presencial o remota).
                        </Text>
                      </Flex>

                      <Box mb={4}>
                        <Text fontSize="sm" color="gray.500" mb={1}>Correo electrónico del colaborador</Text>
                        <Input
                          type="email"
                          placeholder="correo@ejemplo.com"
                          value={correoColaborador}
                          onChange={(e) => setCorreoColaborador(e.target.value)}
                          isRequired
                          bg={listaActivosInputBg}
                        />
                      </Box>

                      <Box>
                        <Text fontSize="sm" color="gray.500" mb={2}>Tu firma (autorización)</Text>
                        {usarFirmaRegistrada ? (
                          <Flex
                            align="center"
                            justify="space-between"
                            gap={3}
                            p={3}
                            border="1px solid"
                            borderColor={borderColor}
                            borderRadius="md"
                            bg={listaActivosInputBg}
                            flexWrap="wrap"
                          >
                            <Box bg="white" p={1} borderRadius="sm">
                              <Image src={firmaRegistrada} alt="Tu firma registrada" h="60px" />
                            </Box>
                            <Button size="sm" variant="outline" onClick={() => setUsarNuevaFirmaAutorizacion(true)}>
                              Usar otra firma
                            </Button>
                          </Flex>
                        ) : (
                          <Box>
                            <Box
                              border="1px dashed"
                              borderColor={borderColor}
                              borderRadius="md"
                              width="100%"
                              height="180px"
                              position="relative"
                              bg="white"
                              overflow="hidden"
                            >
                              <SignatureCanvas
                                ref={sigCanvas}
                                penColor="black"
                                canvasProps={{
                                  width: 450,
                                  height: 180,
                                  style: { width: '100%', height: '100%' }
                                }}
                              />
                            </Box>
                            <Flex gap={2} mt={2}>
                              <Button size="sm" variant="outline" onClick={() => sigCanvas.current?.clear()}>
                                Limpiar firma
                              </Button>
                              {firmaRegistrada && (
                                <Button size="sm" variant="ghost" colorScheme="blue" onClick={() => setUsarNuevaFirmaAutorizacion(false)}>
                                  Usar mi firma registrada
                                </Button>
                              )}
                            </Flex>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  );
                })()}

                {/* Sección mejorada de Activos */}
                <Box>
                  {/* Botón de Reenvío a Revisión */}
                  {!isSoloLectura() && selectedResguardo?.Estado === "Proceso de autorización" && (
                    <Button
                      variant="outline"
                      size="sm"
                      colorScheme="black"
                      leftIcon={<MdRefresh />}
                      mr={3}
                      onClick={async () => {
                        try {
                          // Aquí llamas a tu API para notificar o actualizar el estado de nuevo
                          await enviarActivosActualizados(
                            selectedResguardo.ResguardoId,
                            editableActivos,
                            selectedResguardo.FirmaDigital,
                            false,
                            "Proceso de autorización",
                            undefined,
                            0
                          );

                          toast({
                            title: "Solicitud reenviada",
                            description: "Se ha vuelto a notificar al supervisor para la revisión.",
                            status: "info",
                            duration: 4000,
                            isClosable: true,
                            position: "top-right"
                          });

                          onCloseDrawer();
                        } catch (error) {
                          toast({
                            title: "Error al reenviar",
                            description: "No se pudo procesar el reenvío.",
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                          });
                        }
                      }}
                    >
                      Reenviar a revisión
                    </Button>
                  )}
                  {/* dejamos un espacio */}
                  <Box h="10px" />
                  <Flex justify="space-between" align="center" mb="3">
                    <Text fontSize="md" fontWeight="bold" color="gray.500">Activos Asignados</Text>
                    <Text fontSize="sm" color="gray.500">
                      Total: {editableActivos.length} activo(s)
                    </Text>
                  </Flex>

                  <Box
                    border="1px"
                    borderColor={borderColor}
                    borderRadius="md"
                    overflow="hidden"
                    maxH="300px"
                    overflowY="auto"
                  >
                    <Table variant="simple" size="sm">
                      <Thead bg={useColorModeValue('gray.50', 'gray.700')}>
                        <Tr>
                          {/* Agregar columna de selección cuando esté en modo desasignación */}
                          {modoDesasignacion && (
                            <Th width="50px">
                              <Checkbox
                                isChecked={activosSeleccionados.length === editableActivos.length}
                                isIndeterminate={
                                  activosSeleccionados.length > 0 &&
                                  activosSeleccionados.length < editableActivos.length
                                }
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setActivosSeleccionados(editableActivos.map(a => a.Id));
                                  } else {
                                    setActivosSeleccionados([]);
                                  }
                                }}
                              />
                            </Th>
                          )}
                          <Th>Nombre</Th>
                          <Th>N° Serie</Th>
                          <Th>Acciones</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {isLoadingDrawer ? (
                          <Tr>
                            <Td colSpan={modoDesasignacion ? 4 : 3} textAlign="center" py="6">
                              <Flex direction="column" align="center" gap="2">
                                <Spinner size="md" color="blue.500" thickness="3px" />
                                <Text color="gray.500" fontSize="sm">Cargando activos...</Text>
                              </Flex>
                            </Td>
                          </Tr>
                        ) : editableActivos.length > 0 ? (
                          editableActivos.map((activo, i) => (
                            <Tr
                              key={i}
                              bg={activosSeleccionados.includes(activo.Id) ? 'blue.50' : 'transparent'}
                              borderLeft={activosSeleccionados.includes(activo.Id) ? '4px solid' : 'none'}
                              borderLeftColor="blue.500"
                            >
                              {/* Checkbox de selección individual */}
                              {modoDesasignacion && (
                                <Td>
                                  <Checkbox
                                    isChecked={activosSeleccionados.includes(activo.Id)}
                                    onChange={() => toggleSeleccionActivo(activo.Id)}
                                  />
                                </Td>
                              )}
                              <Td>
                                <Text fontWeight="medium">{activo.ActiveName}</Text>
                                {activo.Modelo && (
                                  <Text fontSize="xs" color="gray.500">Modelo: {activo.Modelo}</Text>
                                )}
                              </Td>
                              <Td>
                                <Badge colorScheme="blue">{activo.SerialNumber}</Badge>
                                {activo.Inventario && (
                                  <Text fontSize="xs" color="gray.500">Inv: {activo.Inventario}</Text>
                                )}
                              </Td>
                              <Td>
                                {selectedResguardo?.Estado === "Recepción confirmada" && (
                                  <Button
                                    size="xs"
                                    colorScheme="red"
                                    variant="outline"
                                    isDisabled={isSoloLectura()}
                                    onClick={() => {
                                      if (modoDesasignacion) {
                                        // Si ya está en modo desasignación, seleccionar/deseleccionar este activo
                                        toggleSeleccionActivo(activo.Id);
                                      } else {
                                        // Si no está en modo desasignación, activar el modo y seleccionar este activo
                                        setModoDesasignacion(true);
                                        setActivosSeleccionados([activo.Id]);
                                      }
                                    }}
                                  >
                                    {modoDesasignacion ?
                                      (activosSeleccionados.includes(activo.Id) ? "Seleccionado" : "Seleccionar")
                                      : "Desasignar"
                                    }
                                  </Button>
                                )}
                                {selectedResguardo?.Estado !== "Recepción confirmada" && (
                                  <Button
                                    size="xs"
                                    colorScheme="red"
                                    variant="outline"
                                    onClick={async () => {
                                      try {
                                        const activoAQuitar = editableActivos[i];

                                        // Verificar si es el último activo
                                        if (editableActivos.length === 1) {
                                          setShowUnicoActivoAlert(true);
                                          return;
                                        }

                                        // 1. Cambiar el estado del activo a "Activo"
                                        await activosApi.editar(activoAQuitar.Id.toString(), {
                                          EstadosId: '1',
                                        });

                                        // 2. Quitar el activo del resguardo
                                        await resguardosApi.quitarDeResguardo(
                                          selectedResguardo.ResguardoId,
                                          activoAQuitar.Id
                                        );

                                        // 3. Actualizar el estado local
                                        const nuevosActivos = editableActivos.filter((_, index) => index !== i);
                                        setEditableActivos(nuevosActivos);
                                        setHayCambiosPendientes(true);

                                        toast({
                                          title: "Activo quitado",
                                          description: `${activoAQuitar.ActiveName} ha sido desasignado`,
                                          status: "success",
                                          duration: 2000,
                                          isClosable: true,
                                        });

                                      } catch (error) {
                                        console.error('Error al quitar el activo:', error);
                                        toast({
                                          title: "Error",
                                          description: "No se pudo quitar el activo",
                                          status: "error",
                                          duration: 3000,
                                          isClosable: true,
                                        });
                                      }
                                    }}
                                    isDisabled={selectedResguardo?.Estado !== "Borrador" || isSoloLectura()}
                                  >
                                    Quitar
                                  </Button>
                                )}
                              </Td>
                            </Tr>
                          ))
                        ) : (
                          <Tr>
                            <Td colSpan={modoDesasignacion ? 4 : 3} textAlign="center" py="4">
                              <Text color="gray.500">No hay activos asignados</Text>
                            </Td>
                          </Tr>
                        )}
                      </Tbody>
                    </Table>
                  </Box>

                  {/* Botones de guardar/cancelar - FUERA de la tabla */}
                  {modoDesasignacion && (
                    <Flex mt="4" p="3" bg="blue.50" borderRadius="md" justify="space-between" align="center">
                      <Text fontSize="sm" fontWeight="medium">
                        {activosSeleccionados.length} activo(s) seleccionado(s) para desasignar
                      </Text>
                      <Flex gap="2">
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={cancelarDesasignacion}
                        >
                          Cancelar
                        </Button>
                        <Button
                          size="sm"
                          colorScheme="red"
                          onClick={() => setDesasignarActivoAviso(true)}
                          isDisabled={activosSeleccionados.length === 0}
                        >
                          Desasignar Seleccionados ({activosSeleccionados.length})
                        </Button>
                      </Flex>
                    </Flex>
                  )}

                  {!isSoloLectura() && (
                  <Box mt="3" p="3" bg={useColorModeValue('gray.50', 'gray.700')} borderRadius="md">
                    <Text fontSize="sm" fontWeight="medium" mb="2">Agregar nuevo activo</Text>
                    {selectedResguardo?.Estado === "Borrador" ? (
                      <Box>
                        <Input
                          placeholder="Buscar por nombre, folio, número de serie o modelo..."
                          value={busquedaNuevoActivo}
                          onChange={(e) => setBusquedaNuevoActivo(e.target.value)}
                          bg={listaActivosInputBg}
                          size="sm"
                          mb="2"
                        />

                        {activosFiltradosPorBusqueda.length === 0 ? (
                          <Text fontSize="sm" color="gray.500" textAlign="center" py="2">
                            {busquedaNuevoActivoNormalizada
                              ? 'No se encontraron activos con ese criterio.'
                              : 'No hay activos disponibles para agregar.'}
                          </Text>
                        ) : (
                          <>
                            <Box maxH="220px" overflowY="auto" borderRadius="md" bg={listaActivosInputBg}>
                              {activosFiltradosPorBusqueda.slice(0, MAX_ACTIVOS_MOSTRADOS).map((activo) => (
                                <Flex
                                  key={activo.Id}
                                  justify="space-between"
                                  align="center"
                                  p="2"
                                  borderBottom="1px solid"
                                  borderColor={listaActivosBorderColor}
                                  _hover={{ bg: listaActivosHoverBg, cursor: 'pointer' }}
                                  onClick={() => agregarActivoAlResguardo(activo)}
                                >
                                  <Box minW="0">
                                    <Text fontSize="sm" fontWeight="600" isTruncated>
                                      {activo.ActiveName}
                                    </Text>
                                    <Text fontSize="xs" color="gray.500" isTruncated>
                                      Serie: {activo.SerialNumber || 'Sin número de serie'} · {activo.Modelo || 'Sin modelo'}
                                      {activo.Folio ? ` · Folio: ${activo.Folio}` : ''}
                                    </Text>
                                  </Box>
                                  <Icon as={MdAdd} color="blue.500" boxSize="5" flexShrink={0} ml="2" />
                                </Flex>
                              ))}
                            </Box>
                            {activosFiltradosPorBusqueda.length > MAX_ACTIVOS_MOSTRADOS && (
                              <Text fontSize="xs" color="gray.500" mt="1">
                                Mostrando {MAX_ACTIVOS_MOSTRADOS} de {activosFiltradosPorBusqueda.length} resultados. Escribe para acotar la búsqueda.
                              </Text>
                            )}
                          </>
                        )}
                      </Box>
                    ) : (
                      <Text color="gray.500" fontSize="sm">
                        No puedes agregar activos en el estado actual ({selectedResguardo?.Estado})
                      </Text>
                    )}
                  </Box>
                  )}
                </Box>

                {selectedResguardo.FirmaDigital && (
                  <Box>
                    <Text fontSize="sm" color="gray.500" mb="2">Firma creador resguardo</Text>
                    <Image
                      src={selectedResguardo.FirmaDigital}
                      alt="Firma digital"
                      maxH="120px"
                      border="1px solid"
                      borderColor={borderColor}
                      borderRadius="md"
                    />
                  </Box>
                )}

                <br />

                <SimpleGrid columns={2} spacing={4}>
                  <Box>
                    <Text fontSize="sm" color="gray.500">Fecha de Creación</Text>
                    <Text fontWeight="medium">
                      {new Date(selectedResguardo.CreatedDate).toLocaleDateString()}
                    </Text>
                  </Box>
                  <Box>
                    <Text fontSize="sm" color="gray.500">Última Modificación</Text>
                    <Text fontWeight="medium">
                      {new Date(selectedResguardo.LastModifiedDate).toLocaleDateString()}
                    </Text>
                  </Box>
                </SimpleGrid>
                {selectedResguardo?.Estado === "Pendiente de firma del colaborador" && (
                  <Box>
                    <Box bg="yellow.50" p={4} borderRadius="md" mb={4} border="1px solid" borderColor="yellow.200">
                      <Text fontSize="sm" color="yellow.700" fontWeight="medium" mb={1}>
                        Enlace de firma enviado a:
                      </Text>
                      <Text fontWeight="bold" color="yellow.800">
                        {selectedResguardo.emailAsociado_resguardo || 'N/A'}
                      </Text>
                      <Text fontSize="xs" color="yellow.600" mt={1}>
                        Si el correo era incorrecto, escribe el correcto abajo y reenvía el enlace.
                      </Text>
                    </Box>
                    <Text fontSize="sm" color="gray.500" mb={1}>Cambiar correo y reenviar</Text>
                    <Input
                      type="email"
                      placeholder={selectedResguardo.emailAsociado_resguardo || "correo@ejemplo.com"}
                      value={correoColaborador}
                      onChange={(e) => setCorreoColaborador(e.target.value)}
                    />
                    <Text fontSize="xs" color="gray.400" mt={1}>
                      Dejar en blanco para reenviar al mismo correo. El enlace anterior quedará inválido.
                    </Text>
                  </Box>
                )}

                {selectedResguardo?.Estado === "Autorizado" && (
                  <Box>
                    <Text fontSize="md" fontWeight="bold" mb={2}>Firma del Colaborador</Text>

                    <Box mb={4}>
                      <Flex justify="space-between" align="center" mb={1}>
                        <Text fontSize="sm" color="gray.500">Correo electrónico del colaborador</Text>
                        <Checkbox
                          size="sm"
                          colorScheme="blue"
                          isChecked={sinCorreo}
                          onChange={(e) => {
                            setSinCorreo(e.target.checked);
                            if (e.target.checked) setCorreoColaborador(""); // Limpia el input si marca que no tiene
                          }}
                        >
                          No cuenta con correo
                        </Checkbox>
                      </Flex>

                      <Input
                        type="email"
                        placeholder={sinCorreo ? "Se enviará al correo default" : "correo@ejemplo.com"}
                        value={correoColaborador}
                        onChange={(e) => setCorreoColaborador(e.target.value)}
                        isDisabled={sinCorreo} // Deshabilitar si se marca el checkbox
                        isRequired={!sinCorreo}
                      />
                      {sinCorreo && (
                        <Text fontSize="xs" color="blue.500" mt={1}>
                          * Se enviará el documento al correo del creador del resguardo.
                        </Text>
                      )}
                    </Box>

                    {/* Selector: define si la firma se envía por correo o se captura en este dispositivo */}
                    <Box mb={4}>
                      <Text fontSize="sm" color="gray.500" mb={2}>¿Cómo se firmará este resguardo?</Text>
                      <SimpleGrid columns={2} spacing={3}>
                        <Box
                          as="button"
                          type="button"
                          onClick={() => setModoFirma('remota')}
                          textAlign="left"
                          p={3}
                          borderRadius="md"
                          border="2px solid"
                          borderColor={modoFirma === 'remota' ? 'blue.400' : borderColor}
                          bg={modoFirma === 'remota' ? modoFirmaSeleccionadoBg : modoFirmaCardBg}
                        >
                          <Flex align="center" gap={2} mb={1}>
                            <Icon as={MdSend} color="blue.500" boxSize={4} />
                            <Text fontWeight="bold" fontSize="sm">Firma remota</Text>
                          </Flex>
                          <Text fontSize="xs" color="gray.500">
                            Se envía un enlace al correo para que el colaborador firme desde su propio dispositivo.
                          </Text>
                        </Box>
                        <Box
                          as="button"
                          type="button"
                          onClick={() => setModoFirma('presencial')}
                          textAlign="left"
                          p={3}
                          borderRadius="md"
                          border="2px solid"
                          borderColor={modoFirma === 'presencial' ? 'blue.400' : borderColor}
                          bg={modoFirma === 'presencial' ? modoFirmaSeleccionadoBg : modoFirmaCardBg}
                        >
                          <Flex align="center" gap={2} mb={1}>
                            <Icon as={MdEdit} color="blue.500" boxSize={4} />
                            <Text fontWeight="bold" fontSize="sm">Firma presencial</Text>
                          </Flex>
                          <Text fontSize="xs" color="gray.500">
                            El colaborador firma ahora mismo, en este dispositivo.
                          </Text>
                        </Box>
                      </SimpleGrid>
                    </Box>

                    {modoFirma === 'remota' && (
                      <Box mb={4} p={3} bg={listaActivosInputBg} border="1px solid" borderColor={borderColor} borderRadius="md">
                        <Checkbox
                          size="sm"
                          colorScheme="blue"
                          isChecked={enviarCopiaCorreos}
                          onChange={(e) => {
                            setEnviarCopiaCorreos(e.target.checked);
                            if (!e.target.checked) setCopiaCorreosInput('');
                          }}
                          mb={2}
                        >
                          Enviar copia a otros correos (opcional)
                        </Checkbox>

                        {enviarCopiaCorreos && (
                          <Box mb={3}>
                            <Input
                              size="sm"
                              placeholder="correo1@ejemplo.com, correo2@ejemplo.com"
                              value={copiaCorreosInput}
                              onChange={(e) => setCopiaCorreosInput(e.target.value)}
                              bg={listaActivosInputBg}
                            />
                            <Text fontSize="xs" color="gray.500" mt={1}>
                              Separa varios correos con comas.
                            </Text>
                          </Box>
                        )}

                        <Text fontSize="sm" color="gray.500" mb={1}>Mensaje personalizado (opcional)</Text>
                        <Textarea
                          size="sm"
                          placeholder="Escribe un mensaje para incluir en el correo del enlace de firma..."
                          value={mensajePersonalizadoCorreo}
                          onChange={(e) => setMensajePersonalizadoCorreo(e.target.value)}
                          bg={listaActivosInputBg}
                          rows={3}
                        />
                      </Box>
                    )}

                    {modoFirma === 'presencial' && (
                      <Box>
                        <Box
                          border="1px dashed"
                          borderColor="gray.300"
                          mb="4"
                          width="100%"
                          height="200px"
                          position="relative"
                          bg="white"
                        >
                          <SignatureCanvas
                            ref={sigCanvas}
                            penColor="black"
                            onEnd={() => setCanvasVacio(sigCanvas.current?.isEmpty() ?? true)} // Detecta cuando deja de firmar
                            onBegin={() => setCanvasVacio(false)} // Detecta cuando empieza a firmar
                            canvasProps={{
                              width: 450,
                              height: 200,
                              style: { width: '100%', height: '100%' }
                            }}
                          />
                        </Box>

                        <Flex gap={3}>
                          <Button onClick={() => sigCanvas.current?.clear()}>
                            Limpiar
                          </Button>
                        </Flex>
                      </Box>
                    )}

                    {!modoFirma && (
                      <Text fontSize="sm" color="gray.500" textAlign="center" py={2}>
                        Selecciona una opción arriba para continuar.
                      </Text>
                    )}
                  </Box>
                )}
              </Stack>
            )}


            {/*   <Stack spacing="20px">
              <Flex align="center" justify="center">
                {(() => {
                  // Declaramos el estado local
                  const [urlImagenNota, setUrlImagenNota] = React.useState<string>("");

                  // Hacemos el fetch si aún no tenemos la URL
                  if (!urlImagenNota) {
                    fetch("https://inventariosbackend.velasresorts.com/inventarios/resguardos/imagenes/notas/60")
                      .then(res => res.json())
                      .then(data => {
                        if (data.message?.URL_Imagen) {
                          setUrlImagenNota(data.message.URL_Imagen);
                        }
                      })
                      .catch(err => console.error("Error al traer la imagen:", err));
                  }

                  // Renderizamos la imagen o un texto de carga
                  return urlImagenNota ? (
                    <img
                      src={urlImagenNota}
                      alt="Imagen nota"
                      style={{ maxWidth: "300px", borderRadius: "8px" }}
                    />
                  ) : (
                    <span>Cargando imagen...</span>
                  );
                })()}
              </Flex>
            </Stack>
 */}

          </DrawerBody>


          <DrawerFooter borderTop="1px" borderColor={borderColor}>
            {!isSoloLectura() && selectedResguardo &&
              ["Recepción confirmada", "Autorizado"].includes(selectedResguardo.Estado) && (
                <Button
                  variant="ghost"
                  colorScheme="red"
                  mr="auto" // Esto lo empuja a la izquierda del footer
                  leftIcon={<MdCancel />}
                  onClick={handleConfirmarCancelacion}
                >
                  Cancelar Resguardo
                </Button>
              )}

            <Button variant="ghost" size="sm" mr={2} onClick={onCloseDrawer}>
              Cerrar
            </Button>

            {selectedResguardo?.Estado === "Recepción confirmada" && (
              <Button
                leftIcon={<MdDownload />}
                colorScheme="teal"
                variant="outline"
                onClick={() => descargarPDF(selectedResguardo.ResguardoId)}
                mr={3}
              >
                Descargar PDF
              </Button>
            )}
            {!isSoloLectura() && selectedResguardo?.Estado === "Pendiente de firma del colaborador" && (
              <Button
                colorScheme="teal"
                variant="outline"
                leftIcon={<Icon as={MdSend} />}
                isLoading={enviandoFirmaRemota}
                loadingText="Reenviando…"
                mr={2}
                onClick={async () => {
                  const correoDestino = correoColaborador || selectedResguardo.emailAsociado_resguardo;
                  if (!correoDestino || !validarEmail(correoDestino)) {
                    toast({
                      title: "Correo requerido",
                      description: "Ingresa un correo válido para reenviar el enlace.",
                      status: "warning",
                      duration: 4000,
                      position: "top-right",
                    });
                    return;
                  }
                  setEnviandoFirmaRemota(true);
                  try {
                    await resguardosApi.enviarSolicitudFirmaRemota(
                      selectedResguardo.ResguardoId,
                      correoDestino
                    );
                    toast({
                      title: "Enlace reenviado",
                      description: `Se reenvió el enlace de firma al correo: ${correoDestino}`,
                      status: "success",
                      duration: 5000,
                      isClosable: true,
                      position: "top-right",
                    });
                    actualizarListaResguardos();
                    onCloseDrawer();
                  } catch {
                    toast({
                      title: "Error al reenviar",
                      description: "No se pudo reenviar el enlace de firma.",
                      status: "error",
                      duration: 5000,
                      isClosable: true,
                      position: "top-right",
                    });
                  } finally {
                    setEnviandoFirmaRemota(false);
                  }
                }}
              >
                Reenviar enlace
              </Button>
            )}
            {/* Mostrar el botón de enviar enlace solo si eligió firma remota */}
            {!isSoloLectura() && selectedResguardo?.Estado === "Autorizado" && modoFirma === 'remota' && (
              <Button
                colorScheme="teal"
                variant="outline"
                leftIcon={<Icon as={MdSend} />}
                isLoading={enviandoFirmaRemota}
                loadingText="Enviando…"
                mr={2}
                onClick={async () => {
                  const correoFinal = sinCorreo
                    ? JSON.parse(sessionStorage.getItem("user") || "{}").Email
                    : correoColaborador;
                  if (!correoFinal || !validarEmail(correoFinal)) {
                    toast({
                      title: "Correo requerido",
                      description: "Ingresa el correo del colaborador antes de enviar el enlace.",
                      status: "warning",
                      duration: 4000,
                      position: "top-right",
                    });
                    return;
                  }

                  const copiaCorreosValidos = enviarCopiaCorreos ? parsearCorreosDeCopia(copiaCorreosInput) : [];
                  if (enviarCopiaCorreos && copiaCorreosInput.trim() && copiaCorreosValidos.length === 0) {
                    toast({
                      title: "Correos de copia inválidos",
                      description: "Revisa los correos que escribiste para la copia, ninguno es válido.",
                      status: "warning",
                      duration: 4000,
                      position: "top-right",
                    });
                    return;
                  }

                  setEnviandoFirmaRemota(true);
                  try {
                    await resguardosApi.enviarSolicitudFirmaRemota(
                      selectedResguardo.ResguardoId,
                      correoFinal,
                      copiaCorreosValidos,
                      mensajePersonalizadoCorreo
                    );
                    toast({
                      title: "Enlace enviado",
                      description: `Se envió el enlace de firma al correo: ${correoFinal}${copiaCorreosValidos.length > 0 ? ` (con copia a ${copiaCorreosValidos.join(', ')})` : ''}`,
                      status: "success",
                      duration: 5000,
                      isClosable: true,
                      position: "top-right",
                    });
                    setModoFirma(null);
                    setEnviarCopiaCorreos(false);
                    setCopiaCorreosInput('');
                    setMensajePersonalizadoCorreo('');
                    actualizarListaResguardos();
                    onCloseDrawer();
                  } catch {
                    toast({
                      title: "Error al enviar",
                      description: "No se pudo enviar el enlace de firma remota.",
                      status: "error",
                      duration: 5000,
                      isClosable: true,
                      position: "top-right",
                    });
                  } finally {
                    setEnviandoFirmaRemota(false);
                  }
                }}
              >
                Enviar enlace de firma
              </Button>
            )}
            {!isSoloLectura() && selectedResguardo?.Estado === "Autorizado" && modoFirma === 'presencial' && (
              <Button
                colorScheme="blue"
                onClick={async () => {

                  //obtenemos user de sessionStorage
                  const userData = JSON.parse(sessionStorage.getItem("user") || "{}");

                  // 1. Determinamos cuál es el correo real a usar en este instante
                  const correoFinal = sinCorreo ? userData.Email : correoColaborador;

                  // 2. Validaciones estrictas
                  if (!sinCorreo && (!correoColaborador || !validarEmail(correoColaborador))) {
                    toast({
                      title: "Correo inválido",
                      description: "Por favor ingresa un correo válido",
                      status: "warning",
                      duration: 3000,
                      position: "top-right"
                    });
                    return;
                  }

                  if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
                    const imageData = sigCanvas.current.getCanvas().toDataURL('image/png');

                    // 3. Pasamos correoFinal directamente para evitar el delay del estado
                    await enviarFirmaColaborador(
                      selectedResguardo.ResguardoId,
                      imageData,
                      correoFinal
                    );

                    setModoFirma(null);
                    actualizarListaResguardos();
                    onCloseDrawer();
                    setSinCorreo(false);
                    setCorreoColaborador(''); // Limpiar para el siguiente
                  } else {
                    toast({
                      title: "Firma requerida",
                      description: "Por favor proporciona tu firma",
                      status: "warning",
                      duration: 5000,
                      isClosable: true,
                      position: "top-right"
                    });
                  }
                }}
                /* --- FIX DEL BUG AQUÍ --- */
                isDisabled={
                  canvasVacio || // Si el canvas está vacío según nuestro estado
                  (!sinCorreo && !validarEmail(correoColaborador)) // Si requiere correo y no es válido
                }
              >
                Guardar Firma
              </Button>
            )}

            {/* Botón de autorizar/enviar a revisión (el formulario de correo+firma vive en el DrawerBody) */}
            {!isSoloLectura() && selectedResguardo?.Estado === "Borrador" && editableActivos.length > 0 && (
              <>
                <Button
                  colorScheme="blue"
                  leftIcon={<Icon as={userData.RolId !== 3 ? MdVerifiedUser : MdSend} />}
                  mr={2}
                  onClick={async () => {
                    if (selectedResguardo) {
                      const userData = JSON.parse(sessionStorage.getItem("user") || "{}");
                      const rolId = userData.RolId || 0;
                      const esSupervisor = rolId !== 3;
                      const firmaRegistrada = userData.Firma && userData.Firma.toLowerCase() !== 'sin firma registrada'
                        ? userData.Firma : null;
                      const usarFirmaRegistrada = !!firmaRegistrada && !usarNuevaFirmaAutorizacion;

                      // Validaciones para supervisores
                      if (esSupervisor) {
                        if (!correoColaborador) {
                          toast({
                            title: "Correo requerido",
                            description: "Por favor ingresa el correo electrónico del colaborador",
                            status: "warning",
                            duration: 5000,
                            isClosable: true,
                            position: "top-right"
                          });
                          return;
                        }

                        if (!usarFirmaRegistrada && sigCanvas.current?.isEmpty()) {
                          toast({
                            title: "Firma requerida",
                            description: "Por favor proporciona tu firma digital",
                            status: "warning",
                            duration: 5000,
                            isClosable: true,
                            position: "top-right"
                          });
                          return;
                        }
                      }

                      try {
                        const estadoFinal = esSupervisor ? "Autorizado" : "Proceso de autorización";
                        const firmaDigital = esSupervisor
                          ? (usarFirmaRegistrada ? firmaRegistrada : sigCanvas.current?.getCanvas().toDataURL('image/png'))
                          : selectedResguardo.FirmaDigital;

                        // Guardar datos en sessionStorage
                        if (esSupervisor) {
                          const colaborador = JSON.parse(sessionStorage.getItem("colaborador") || "{}");
                          sessionStorage.setItem("colaborador", JSON.stringify({
                            ...colaborador,
                            email: correoColaborador
                          }));
                        }

                        await enviarActivosActualizados(
                          selectedResguardo.ResguardoId,
                          editableActivos,
                          firmaDigital,
                          false,
                          estadoFinal,
                          esSupervisor ? correoColaborador : undefined,
                          esSupervisor ? 1 : 0 // Enviar indicador soloSupervisor
                        );

                        setHayCambiosPendientes(false);
                        toast({
                          title: esSupervisor ? "Resguardo autorizado" : "Resguardo enviado a revisión",
                          description: esSupervisor
                            ? "Ahora falta la firma de quien recibirá los activos: elige firma presencial o remota."
                            : "El resguardo ha sido enviado a revisión correctamente",
                          status: "success",
                          duration: 6000,
                          isClosable: true,
                          position: "top-right"
                        });

                        const res = await resguardosApi.listadoId(userHotelIds);
                        const formattedData = await construirFilasResguardos(res);
                        setData(formattedData);

                        if (esSupervisor) {
                          // El resguardo no está terminado: falta que la persona que recibe
                          // los activos firme (presencial o remota). Dejamos el drawer abierto
                          // y lo movemos directo a la sección "Firma del Colaborador", limpiando
                          // el canvas que se acaba de usar para la firma de autorización.
                          sigCanvas.current?.clear();
                          setCanvasVacio(true);
                          setModoFirma(null);
                          setUsarNuevaFirmaAutorizacion(false);
                          setSelectedResguardo(prev => prev ? { ...prev, Estado: "Autorizado" } : prev);
                        } else {
                          onCloseDrawer();
                        }

                      } catch (error) {
                        toast({
                          title: "Error al procesar",
                          description: "Ocurrió un error al procesar el resguardo",
                          status: "error",
                          duration: 5000,
                          isClosable: true,
                          position: "top-right"
                        });
                      }
                    }
                  }}
                  disabled={
                    !hayCambiosPendientes ||
                    (userData.RolId !== 3 && (
                      (!sinCorreo && (!correoColaborador || !validarEmail(correoColaborador))) ||
                      (!(userData.Firma && userData.Firma.toLowerCase() !== 'sin firma registrada' && !usarNuevaFirmaAutorizacion) &&
                        sigCanvas.current && sigCanvas.current.isEmpty())
                    ))
                  }
                >
                  {userData.RolId !== 3 ? "Autorizar" : "Enviar a revisión"}
                </Button>
              </>
            )}
            {/* <Button colorScheme="teal">Imprimir</Button> */}
          </DrawerFooter>

        </DrawerContent>
      </Drawer>
      <AlertDialog
        isOpen={showCancelAlert}
        leastDestructiveRef={cancelRef}
        onClose={() => {
          setShowCancelAlert(false);
          setMotivoCancelacion('');
        }}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Cancelar Resguardo
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Estás seguro? Cancelar el resguardo conlleva <strong>desasignar los activos</strong>,
              pero quedará un historial de esto en el sistema para futuras consultas.
              <FormControl mt={4} isRequired>
                <FormLabel fontSize="sm">Motivo de la cancelación</FormLabel>
                <Textarea
                  value={motivoCancelacion}
                  onChange={(e) => setMotivoCancelacion(e.target.value)}
                  placeholder="Describe por qué se cancela este resguardo…"
                  size="sm"
                />
              </FormControl>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={() => {
                  setShowCancelAlert(false);
                  setMotivoCancelacion('');
                }}
              >
                No, regresar
              </Button>
              <Button
                colorScheme="red"
                onClick={ejecutarCancelacionReal}
                isLoading={isLoadingDrawer}
                loadingText="Cargando activos…"
                isDisabled={isLoadingDrawer || !motivoCancelacion.trim()}
                ml={3}
              >
                Sí, cancelar resguardo
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {showSignaturePad && (
        <SignaturePadModal
          onSave={(signature) => {
            setNuevaFirmaDigital(signature);
            setShowSignaturePad(false);
            setHayCambiosPendientes(true);
          }}
          onClose={() => setShowSignaturePad(false)}
        />
      )}
    </Flex>



  );
}